import React from "react";
import ASSETS from "../../data/assets";

const AuthLayout = ({ children }) => (
  <div className="flex min-h-screen flex-col lg:flex-row">
      <div className="flex-1 flex items-center justify-center bg-white px-4 sm:px-8 py-8 lg:py-0">
      <div className="w-full max-w-[404px]">{children}</div>
    </div>
    {/* Right image — hidden on mobile/tablet, shown on laptop+ */}
    <div className="hidden lg:block lg:w-[40%] xl:w-[41%] relative flex-shrink-0 overflow-hidden rounded-l-[32px]">
      <img src={ASSETS.authRight} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 flex items-center justify-center">
        <img src={ASSETS.logo} alt="Fa1th Hook" className="w-[160px] h-[160px] xl:w-[260px] xl:h-[236px] object-contain" />
      </div>
    </div>
  </div>
);

export default AuthLayout;
